import { render, staticRenderFns } from "./ContestAdv.vue?vue&type=template&id=2858eec1&"
import script from "./ContestAdv.vue?vue&type=script&lang=js&"
export * from "./ContestAdv.vue?vue&type=script&lang=js&"
import style0 from "./ContestAdv.vue?vue&type=style&index=0&id=2858eec1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports